import type { PartialDeal } from "../../types/deal";

/** Starting shape for a brand-new deal form. */
export const emptyDeal: PartialDeal = {
  deal_name: "",
  deal_name_alias: "",
  loan_amount_day_one: null,
  loan_amount_fully_funded: null,
  loan_amount_currency: "",
  is_funded: false,
  is_portfolio: false,
  ltv: null,
  source: "",
  source_id: null,
  source_entity: null,
  ltc: null,
  has_complete_term_sheet: false,
  has_complete_ten_pager: false,
  is_development_loan: false,
  nda_id: null,
  nda: null,
  countries: [],
  sectors: [],
  status: { id: 9, status: "Received Materials", sort_order: 11 },
  sponsor: undefined,
  secondary_sponsor: undefined,
  borrowers: [],
  secondary_borrowers: [],
  deal_lead: undefined,
  deal_support: undefined,
  loan_type: { id: 1, loan_type: "Senior" },
  security_type: undefined,
  transaction_type: undefined,
  risk_class: undefined,
  deal_purpose: "",
  deal_summary: "",
  risks: "",
  strategy: "",
  market_summary: "",
  amortisation: false,
  amortisation_amount: null,
  amortisation_percentage: null,
  capital_source: { id: 1, name: "Athene" },
};

/** Strip config metadata; map legacy servicing_fee → tf_servicing_fee. */
export function dealConfigRowToPartialDeal(
  row: Record<string, unknown>,
): PartialDeal {
  const omit = new Set(["name", "updated_at", "capital_source_id", "id"]);
  const out: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(row)) {
    if (omit.has(key)) continue;
    out[key] = value;
  }
  if (out.tf_servicing_fee == null && row.servicing_fee != null) {
    out.tf_servicing_fee = row.servicing_fee;
  }
  delete out.servicing_fee;
  return out as PartialDeal;
}
